import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from '../reducers/session.reducer';
import { SESSION_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<SessionState>(SESSION_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: SessionState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: SessionState) => state.loading);
export const selectSession = createSelector(selectState, (state: SessionState) => state.user);
